import CookieConsent from "vanilla-cookieconsent/dist/cookieconsent.umd";
import logoSos from "./../images/sos_pare-brise_plus_logo-mini.png";
// obtain plugin

// microsoft logo
var logo =
  '<img class="logo-page" height="30" width="30" src="' +
  logoSos +
  '" alt = "Logo SOS PARABRISAS®" />';
var cookie = "🍪";

/**
 * All config. options available here:
 * https://cookieconsent.orestbida.com/reference/configuration-reference.html
 */
CookieConsent.run({
  // root: 'body',
  // autoShow: true,
  disablePageInteraction: true,
  // hideFromBots: true,
  // mode: 'opt-in',
   revision: 1,

  cookie: {
    name: "cc_cookie",
    // domain: location.hostname,
    // path: '/',
    // sameSite: "Lax",
    expiresAfterDays: (acceptType) => {
      return acceptType === "all" ? 365.25 : 1;
    },
  },

  // https://cookieconsent.orestbida.com/reference/configuration-reference.html#guioptions
  guiOptions: {
    consentModal: {
      layout: "box",
      position: "middle center",
      equalWeightButtons: false,
      flipButtons: false,
    },
    preferencesModal: {
      layout: "box",
      equalWeightButtons: false,
      flipButtons: false,
    },
  },

  onFirstConsent: ({ cookie }) => {
    //console.log("onFirstConsent fired", cookie);
  },

  onConsent: ({ cookie }) => {
    //console.log("onConsent fired!", cookie);
    updateGtagConsent();
  },

  onChange: ({ changedCategories, changedServices }) => {
   // console.log("onChange fired!", changedCategories, changedServices);
    updateGtagConsent();
  },

  onModalReady: ({ modalName }) => {
   // console.log("ready:", modalName);
  },

  onModalShow: ({ modalName }) => {
   // console.log("visible:", modalName);
  },

  onModalHide: ({ modalName }) => {
   // console.log("hidden:", modalName);
  },

  categories: {
    necessary: {
      enabled: true, // this category is enabled by default
      readOnly: true, // this category cannot be disabled
    },
    analytics: {
      autoClear: {
        cookies: [
          {
            name: /^_ga/, // regex: match all cookies starting with '_ga'
          },
          {
            name: "_gid", // string: exact cookie name
          },
        ],
      },

      // https://cookieconsent.orestbida.com/reference/configuration-reference.html#category-services
      // services: {
      //   ga: {
      //     label: "Google Analytics",
      //     onAccept: () => {},
      //     onReject: () => {},
      //   },
      // },
    },
    ads: {
      enabled: false,
      readOnly: false,
    },
  },

  language: {
    default: "fr",
    translations: {
      //   en: {
      //     consentModal: {
      //       title: "We use cookies",
      //       description:
      //         "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua",
      //       acceptAllBtn: "Accept all",
      //       acceptNecessaryBtn: "Reject all",
      //       showPreferencesBtn: "Manage Individual preferences",
      //       // closeIconLabel: 'Reject all and close modal',
      //       footer: `
      //                     <a href="#path-to-impressum.html" target="_blank">Impressum</a>
      //                     <a href="#path-to-privacy-policy.html" target="_blank">Privacy Policy</a>
      //                 `,
      //     },
      //     preferencesModal: {
      //       title: "Manage cookie preferences",
      //       acceptAllBtn: "Accept all",
      //       acceptNecessaryBtn: "Reject all",
      //       savePreferencesBtn: "Accept current selection",
      //       closeIconLabel: "Close modal",
      //       serviceCounterLabel: "Service|Services",
      //       sections: [
      //         {
      //           title: "Your Privacy Choices",
      //           description: `In this panel you can express some preferences related to the processing of your personal information. You may review and change expressed choices at any time by resurfacing this panel via the provided link. To deny your consent to the specific processing activities described below, switch the toggles to off or use the “Reject all” button and confirm you want to save your choices.`,
      //         },
      //         {
      //           title: "Strictly Necessary",
      //           description:
      //             "These cookies are essential for the proper functioning of the website and cannot be disabled.",

      //           //this field will generate a toggle linked to the 'necessary' category
      //           linkedCategory: "necessary",
      //         },
      //         {
      //           title: "Performance and Analytics",
      //           description:
      //             "These cookies collect information about how you use our website. All of the data is anonymized and cannot be used to identify you.",
      //           linkedCategory: "analytics",
      //           cookieTable: {
      //             caption: "Cookie table",
      //             headers: {
      //               name: "Cookie",
      //               domain: "Domain",
      //               desc: "Description",
      //             },
      //             body: [
      //               {
      //                 name: "_ga",
      //                 domain: location.hostname,
      //                 desc: "Description 1",
      //               },
      //               {
      //                 name: "_gid",
      //                 domain: location.hostname,
      //                 desc: "Description 2",
      //               },
      //             ],
      //           },
      //         },
      //         {
      //           title: "Targeting and Advertising",
      //           description:
      //             "These cookies are used to make advertising messages more relevant to you and your interests. The intention is to display ads that are relevant and engaging for the individual user and thereby more valuable for publishers and third party advertisers.",
      //           linkedCategory: "ads",
      //         },
      //         {
      //           title: "More information",
      //           description:
      //             'For any queries in relation to my policy on cookies and your choices, please <a href="#contact-page">contact us</a>',
      //         },
      //       ],
      //     },
      //   },
      fr: {
        consentModal: {
          title: cookie + "Vous avez le contrôle de vos données",
          description:
            "Chez SOS PARE-BRISE+®, nous utilisons des cookies et autres traceurs. <br/>Certains sont indispensables au fonctionnement de notre site, d’autres nécessitent votre consentement. Vous pouvez les accepter ou les refuser librement et modifier votre choix à tout moment, sans que cela ne perturbe votre navigation sur notre site.",
          acceptAllBtn: "Tout accepter",
          acceptNecessaryBtn: "Tout refuser",
          showPreferencesBtn: "Laissez-moi choisir",
          // closeIconLabel: 'Reject all and close modal',
          footer: `
                        
                        <a href="https://www.sosparebriseplus.fr/mentions-legales/" target="_blank">Politique de Protection des Données Personnelles</a>
                    `,
        },
        preferencesModal: {
          title: "Préférences de cookies",
          acceptAllBtn: "Tout accepter",
          acceptNecessaryBtn: "Tout rejeter",
          savePreferencesBtn: "Sauvegarder les préférences",
          closeIconLabel: "Fermer la modale",
          serviceCounterLabel: "Services",
          sections: [
            {
              title: "Vos choix en matière de confidentialité",
              description: `Dans ce panneau, vous pouvez exprimer certaines préférences liées au traitement de vos informations personnelles. Vous pouvez revoir et modifier les choix exprimés à tout moment en refaisant surface ce panneau via le lien fourni. Pour refuser votre consentement aux activités de traitement spécifiques décrites ci-dessous, désactivez les boutons ou utilisez le bouton « Tout rejeter » et confirmez que vous souhaitez enregistrer vos choix.`,
            },
            {
              title:
                'Cookies Strictement Nécessaires <span class="pm__badge">Toujours Activé</span>',
              description:
                "Ces cookies sont indispensables au bon fonctionnement du site Internet et ne peuvent être désactivés.",

              //this field will generate a toggle linked to the 'necessary' category
              linkedCategory: "necessary",
            },
            {
              title: "Performances et suivi Analytics",
              description:
                "Ces cookies collectent des informations sur la façon dont vous utilisez notre site Web. Toutes les données sont anonymisées et ne peuvent pas être utilisées pour vous identifier.",
              linkedCategory: "analytics",
              cookieTable: {
                caption: "Cookie table",
                headers: {
                  name: "Cookie",
                  domain: "Domain",
                  desc: "Description",
                },
                body: [
                  {
                    name: "_ga",
                    domain: location.hostname,
                    desc: "Le cookie _ga, installé par Google Analytics, calcule les visiteurs, les sessions, les données de campagne et assure également le suivi de l'utilisation du site pour le rapport d'analyse du site. Le cookie stocke les informations de manière anonyme et attribue un numéro généré de manière aléatoire pour reconnaître les visiteurs uniques.",
                  },
                  {
                    name: "_gid",
                    domain: location.hostname,
                    desc: "Installé par Google Analytics, le cookie _gid stocke des informations sur la façon dont les visiteurs utilisent un site Web, tout en créant un rapport d'analyse des performances du site Web.Certaines des données collectées incluent le nombre de visiteurs, leur source et les pages qu'ils visitent de manière anonyme.",
                  },
                ],
              },
            },
            {
              title: "Ciblage et publicité",
              description:
                "Ces cookies sont utilisés pour rendre les messages publicitaires plus pertinents par rapport à vous et à vos intérêts. L'intention est d'afficher des publicités pertinentes et attrayantes pour l'utilisateur individuel et donc plus intéressantes pour les éditeurs et les annonceurs tiers.",
              linkedCategory: "ads",
            },
            {
              title: "Plus d'information",
              description:
                'Pour toute question relative à ma politique en matière de cookies et à vos choix, veuillez nous contacter <a href="mailto:info@sosparebriseplus.fr">info@sosparebriseplus.fr</a>',
            },
          ],
        },
      },
      es: {
        consentModal: {
          title: cookie + "Tú tienes el control de tus datos",
          description:
            "En SOS PARABRISAS® utilizamos cookies y otros rastreadores. <br/>Algunas son esenciales para el funcionamiento de nuestro sitio, otras requieren su consentimiento. Puede aceptarlas o rechazarlas libremente y modificar su elección en cualquier momento, sin interrumpir su navegación en nuestro sitio.",
          acceptAllBtn: "Aceptar todo",
          acceptNecessaryBtn: "Rechazar todo",
          showPreferencesBtn: "Dejame elegir",
          // closeIconLabel: 'Reject all and close modal',
          footer: `
                        
                        <a href="https://www.sosparabrisas.es/menciones-legales/" target="_blank">Política de Protección de Datos Personales</a>
                    `,
        },
        preferencesModal: {
          title: "Preferencias de cookies",
          acceptAllBtn: "Aceptar todo",
          acceptNecessaryBtn: "Rechazar todo",
          savePreferencesBtn: "Guardar preferencias",
          closeIconLabel: "Cerrar modal",
          serviceCounterLabel: "Servicios",
          sections: [
            {
              title: "Tus opciones de privacidad",
              description: `En este panel usted puede expresar ciertas preferencias relacionadas con el procesamiento de su información personal. Puede revisar y modificar las opciones expresadas en cualquier momento haciendo resurgir este panel a través del enlace proporcionado. Para rechazar su consentimiento para las actividades de procesamiento específicas que se describen a continuación, desactive los botones o utilice el botón "Rechazar todo" y confirme que desea guardar sus opciones.`,
            },
            {
              title:
                'Cookies estrictamente necesarias <span class="pm__badge">Siempre activas</span>',
              description:
                "Estas cookies son esenciales para el correcto funcionamiento del sitio web y no se pueden desactivar.",

              //this field will generate a toggle linked to the 'necessary' category
              linkedCategory: "necessary",
            },
            {
              title: "Seguimiento de rendimiento y análisis",
              description:
                "Estas cookies recopilan información sobre cómo utiliza nuestro sitio web. Todos los datos son anónimos y no pueden utilizarse para identificarle.",
              linkedCategory: "analytics",
              cookieTable: {
                caption: "Cookie table",
                headers: {
                  name: "Cookie",
                  domain: "Dominio",
                  desc: "Descripción",
                },
                body: [
                  {
                    name: "_ga",
                    domain: location.hostname,
                    desc: "La cookie _ga, instalada por Google Analytics, calcula los visitantes, las sesiones, los datos de la campaña y también rastrea el uso del sitio para el informe analítico del sitio. La cookie almacena información de forma anónima y asigna un número generado aleatoriamente para reconocer visitantes únicos.",
                  },
                  {
                    name: "_gid",
                    domain: location.hostname,
                    desc: "Instalada por Google Analytics, la cookie _gid almacena información sobre cómo los visitantes utilizan un sitio web, al tiempo que crea un informe de análisis sobre el rendimiento del sitio web. Algunos de los datos recopilados incluyen el número de visitantes, su fuente y las páginas que visitan de forma anónima.",
                  },
                ],
              },
            },
            {
              title: "Orientación y publicidad",
              description:
                "Estas cookies se utilizan para hacer que los mensajes publicitarios sean más relevantes para usted y sus intereses. La intención es mostrar anuncios que sean relevantes y atractivos para el usuario individual y, por lo tanto, más interesantes para los editores y anunciantes externos.",
              linkedCategory: "ads",
            },
            {
              title: "Más información",
              description:
                'Para cualquier duda relacionada con mi política de cookies y sus opciones, por favor contáctenos <a href="mailto:info@sosparabrisas.es">info@sosparabrisas.es</a>',
            },
          ],
        },
      },
    },
  },
});
function updateGtagConsent() {
  const consentData = {
    ad_storage: CookieConsent.acceptedCategory("ads") ? "granted" : "denied",
    ad_user_data: CookieConsent.acceptedCategory("ads") ? "granted" : "denied",
    ad_personalization: CookieConsent.acceptedCategory("ads") ? "granted" : "denied",
    analytics_storage: CookieConsent.acceptedCategory("analytics") ? "granted" : "denied",
    functionality_storage: CookieConsent.acceptedCategory("necessary") ? "granted" : "denied",
    personalization_storage: CookieConsent.acceptedCategory("necessary") ? "granted" : "denied",
  };
  gtag("consent", "update", consentData);

  // Push consent data to the Data Layer
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "consent_update",
    ...consentData,
  });
}
